import {CloseOutlined, RightOutlined} from '@ant-design/icons'
import {Divider} from 'antd'
import navigationConfig from 'configs/NavigationConfig'
import React, {useEffect} from 'react'
import {Link} from 'react-router-dom'
import './mobileMenu.css'
import {useDispatch, useSelector} from "react-redux";
import {getSocialIcon} from "../../redux/actions";
import {FacebookIcon, LinkedInIcon, WhatsAppIcon, TwitterIcon, InstagramIcon, TelegramIcon, SnapChatIcon} from "../../assets/svg/icon";


function MobileMenu({setMenuOpen, setLinksPopupVisible}) {
    const {socialIcon} = useSelector(state => state.fetchedData);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSocialIcon());
    }, []);

    const socialIcons = {
        instagram: InstagramIcon,    // '/img/social/instagram.svg',
        facebook: FacebookIcon,    // '/img/social/facebook.svg',
        telegram: TelegramIcon,    // '/img/social/Telegram-Logo.svg',
        snapchat: SnapChatIcon,    // '/img/social/snapchat.svg',
        twitter: TwitterIcon,    // '/img/social/twitter.svg',
        whatsapp: WhatsAppIcon,    // '/img/social/whatsapp.svg',
        linkedin: LinkedInIcon,    // '/img/social/linkedin.svg',
    };

    const showLinksPopup = () => {
        setLinksPopupVisible(true);
        localStorage.setItem('linksPopupShowed', true);
    }

    return (
        <div className="mobileMenu">
            <div className='mb-3'>
                <CloseOutlined onClick={() => setMenuOpen(false)}
                               style={{fontWeight: 'bold', fontSize: '24px', color: 'black', cursor: 'pointer'}}/>
            </div>
            {navigationConfig.map(menu => <Link to={menu.path} key={menu.key}>
                <div onClick={() => setMenuOpen(false)} className="d-flex justify-content-between align-items-center">
                    <div className="px-4 py-3" style={{fontSize: '16px', color: '#212121'}}>{menu.title}</div>
                    <RightOutlined style={{color: '#B3B3B3'}}/>
                </div>
                <Divider className='my-0'/>
            </Link>)}
            <div onClick={showLinksPopup} className="d-flex justify-content-between align-items-center cursor-pointer">
                    <div className="px-4 py-3" style={{fontSize: '16px', color: '#212121'}}>Links</div>
                    <RightOutlined style={{color: '#B3B3B3'}}/>
            </div>
            <div className={"mobileMenuAction"}>
                { socialIcon?.map((item, index) => <a href={item.link} key={index} style={{marginLeft: "5px"}} target={"blank"}>
                    {socialIcons[item?.icon]}
                </a>)
                }
            </div>
        </div>
    )
}

export default MobileMenu;